import 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import 'bootstrap';
import Global from 'models/Global';
import AddToCalendarView from 'web-common/scripts/views/AddToCalendarView';
import template from 'hbars!templates/sessionView';
import readMore from './ReadMore';
import { fetchMarkerData } from './Utils';

var SessionView = Backbone.View.extend({

    events: {
        'click .session-like-btn': 'likeSession',
        'click .dropdown-add-session': 'addSessionClicked',
        'click .dropdown-remove-session': 'removeSessionClicked'
    },

    tagName: 'li',

    className: 'row session-panel form-group color-5-background',

    initialize: function() {
        this.agenda = Global.get('agenda');
        this.me = Global.get('me');
        this.event = Global.get('event');
        this.model.set('unique-name', this.event.get('unique-name'));
        this.addToCalendarView = new AddToCalendarView({event: this.event, session: this.model});

        fetchMarkerData('like', 'sessions', this);
        fetchMarkerData('addToCal', 'sessions', this);
        fetchMarkerData('likeCount', 'sessions', this, 'likesCount');

        this.listenTo(this.model.get('tracks'), 'change:disabled', this.setVisibilty);
        this.listenTo(this.model, 'sessionLike', this.render);
        this.listenTo(this.model, 'sessionFavorite', this.render);
        this.listenTo(this.agenda, 'viewState', this.setVisibilty);
        this.setVisibilty();
    },

    redirectToCommunity: function() {
        const url = this.event.getCommunityUrl();
        window.location = url;
    },

    addSessionClicked: function() {
        if (!this.me.get('isJoined')) {
            this.redirectToCommunity();
            return;
        }
        this.model.addToCalendar({shouldAdd: true});
    },

    removeSessionClicked: function() {
        this.model.addToCalendar({shouldAdd: false});
    },

    likeSession: function() {
        if (this.disableMultiClick) {
            return;
        }

        this.disableMultiClick = true;
        if (!this.me.get('isJoined')) {
            this.redirectToCommunity();
            return;
        }

        const thisView = this;
        if (this.model.get('markersData').like) {
            this.model.like({shouldLike: false});
        } else {
            this.$('.icon-like').toggleClass('animated', true);
            _.delay(function(){
                thisView.$('.icon-like').toggleClass('animated', false);
                thisView.model.like({shouldLike: true});
            }, 2000);
        }
    },

    setVisibilty: function() {
        const myView = this.agenda.get('viewState') === 'myView';
        const visibleTracks = this.model.hasVisibleTracks();
        this.model.set('isHidden', !visibleTracks || (myView && !this.model.get('markersData').addToCal));
        this.render();
        this.model.collection.trigger('visibilityChanged');
    },

    remove: function() {
        this.addToCalendarView.remove();
        return Backbone.View.prototype.remove.call(this);
    },

    render: function() {
        this.disableMultiClick = false;
        var html = template(_.extend(this.model.toJSON(), {event: this.event.toJSON()}));
        this.$el.html(html);
        this.addToCalendarView.setElement(this.$('.add-to-calendar')).render();
        this.$el.toggleClass('hide', this.model.get('isHidden'));
        if (!this.me.get('isJoined')) {
            this.$('.joined-only-tooltip').tooltip({});
        }
        this.$el.addClass('session-' + this.model.get('id'));
        this.$('.track-circle').tooltip({});
        readMore(this.$('.session-description'), {
            speed: 200,
            maxHeight: 38,
            moreLink: '<a class="session-readmore-action-link color-3">Read more</a>',
            lessLink: '<a class="session-readmore-action-link color-3">Close</a>'
        });

        return this;
    }

});

export default SessionView;


